import React from 'react';
import isEqual from 'lodash.isequal';
import cssClasses from './Cell.css';

const getCellClassName = (column, row, x, y, focusedCell, disabled, resizingColumn) => {
    let classes = [cssClasses.cell];
    if (isEqual(focusedCell.coords, { x, y })) classes.push(cssClasses.focusedCell);
    if (resizingColumn && resizingColumn.column.id === column.id) classes.push(cssClasses.resizingCell);
    if (disabled) classes.push(cssClasses.disabledElement);
    if (column.getCellClassName) classes.push(column.getCellClassName(row));
    return classes.join(' ');
}

const isActiveCell = (focusedCell, coords, disabled) => {
    return isEqual(focusedCell.coords, coords) && !disabled && focusedCell.active;
}

const Cell = (props) => {
    const { y, column, row, columnsCount, rowsCount, height, rowheight, index, columnWidthList, focusedCell, setCellDirectly, resizingColumn, disabled } = props;
    let width;
    const coords = { x: index, y };
    if (height < (rowheight * rowsCount) && y === columnsCount - 1)
        width = columnWidthList[column.id] - 15;
    else
        width = columnWidthList[column.id];

    return <div key={y} data-resize-column-id={column.id} data-cell-x={index} data-y={y} data-tab={column.tabStop} onMouseDown={() => setCellDirectly(index, y, false, isEqual(focusedCell.coords, coords), isActiveCell(focusedCell, coords, disabled), disabled)} className={getCellClassName(column, row, index, y, focusedCell, disabled, resizingColumn)}
        style={{ width: width + 'px' }}>{column.value(row, {
            focus: isEqual(focusedCell.coords, coords), active: isActiveCell(focusedCell, coords, disabled), disabled,
            coords: { x: index, y: y }, width: width
        })}</div>
}

export default Cell;


// WEBPACK FOOTER //
// ./src/components/DataTable/Body/Row/Cell/Cell.js